import { TranslocoConfig } from '@jsverse/transloco';

export const TranslateConfig = {
  availableLangs: ['en', 'fr'],
  reRenderOnLangChange: true,
  fallbackLang: 'fr',
  missingHandler: { useFallbackTranslation: true },
  defaultLang: 'fr',
} as TranslocoConfig;
